/**
 * Array Utilities
 *
 * Collection of utility functions for array manipulation and operations.
 */

/**
 * Shuffle an array using Fisher-Yates algorithm
 * @param {Array} array - Array to shuffle
 * @returns {Array} Shuffled copy of the array (does not mutate original)
 * @example
 * const items = [1, 2, 3, 4, 5]
 * const shuffled = shuffleArray(items)
 * // Original array is unchanged
 */
export function shuffleArray(array) {
  const shuffled = [...array]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}
